export default __webpack_public_path__ + "static/media/backend-guild-badge.f0f75be6.png";